import React, {Component} from "react";
import {OptionalTableCell} from "../../../shared/component/OptionalTableCell";

export class LoanDetailsTableLoanOfficerPhone extends Component<{ phone: string }> {
    render() {
        return <OptionalTableCell title='Loan Officer Phone'>
            {this.props.phone}
        </OptionalTableCell>;
    }
}